<template>
<div>
  <vx-card>
    <div>
      <label class="vs-input--label">Messaging profile</label>
      <v-select
        name="profile"
        label="name"
        :options="profiles"
        @input="getValue"
      />
    </div>
    <p>Number of DIDs  300</p>
    <vs-button
      class="mt-3 w-auto"
    >Import Now</vs-button>
  </vx-card>
</div>
</template>

<script>
import vSelect from 'vue-select'
import TableMixin from '@/mixins/table.js'

export default {
  components: {
    vSelect,
  },
  mixins: [TableMixin],
  data() {
    return {
      profiles: [],
      payload: {
        profile: null
      }
    }
  },
  methods: {
    getValue(e) {
      this.payload.profile = e
    },
  }
}
</script>

<style scoped>

</style>
